export const JobFieldRenderer = ({ field, context }) => {
  const FieldComponent = field.component;
  const fieldProps = field.getProps ? field.getProps(context) : {};

  return <FieldComponent {...fieldProps} />;
};
